// src/hooks/useLogAppOpen.js
import { useEffect, useRef } from 'react';
import { logAppOpen } from '../utils/appEventsUtils';

/**
 * Хук для логирования события app_open при монтировании приложения.
 * Вызывается один раз за сессию (при загрузке/перезагрузке страницы).
 * 
 * @param {string|null|undefined} userId - ID текущего пользователя (session?.user?.id)
 * @param {string} path - Текущий путь (window.location.pathname)
 */
export function useLogAppOpen(userId, path = '/') {
    const loggedRef = useRef(false);

    useEffect(() => {
        // Если пользователь не авторизован, ждем авторизации
        if (!userId) return;

        // Логируем только один раз за сессию приложения (SPA)
        if (loggedRef.current) return;

        // Помечаем, что начали логирование
        loggedRef.current = true;

        // Отправляем событие app_open
        logAppOpen(userId, path)
            .then(({ success, error }) => {
                if (!success) {
                    console.warn('[useLogAppOpen] Failed to log app_open, will not retry');
                }
            });
    }, [userId, path]); // Следим за userId: сработает, когда сессия инициализируется


}
